"use client";

import type { ReactElement } from "react";
import { AnimatePresence } from "framer-motion";
import { Cprepage } from "@/components/ui/Cprepage";

interface LandingPagePrepageOverlayProps {
  showPrepage: boolean;
}

export function LandingPagePrepageOverlay({
  showPrepage,
}: LandingPagePrepageOverlayProps): ReactElement {
  return (
    <AnimatePresence>
      {showPrepage && <Cprepage key="prepage" />}
    </AnimatePresence>
  );
}
